import service from './service';
import serviceCategory from './serviceCategory';
import blogPost from './blogPost';
import homePage from './homePage';
import aboutPage from './aboutPage';
import workshopPage from './workshop';
import faqItem from './faqItem';
import servicesPage from './servicesPage';
import contactPage from './contactPage';
import termsPage from './termsPage';
import privacyPage from './privacyPage';
import siteSettings from './siteSettings';
import booking from './booking';

// Section schemas
import heroSection from './sections/heroSection';
import uspSection from './sections/uspSection';
import servicesSection from './sections/servicesSection';
import videoSection from './sections/videoSection';
import topSellersSection from './sections/topSellersSection';
import workshopsSection from './sections/workshopsSection';
import testimonialsSection from './sections/testimonialsSection';
import partnersSection from './sections/partnersSection';
import statsSection from './sections/statsSection';
import faqSection from './sections/faqSection';

// Object schemas
import workshopObject from './objects/workshop';
import testimonial from './objects/testimonial';
import partner from './objects/partner';
import stat from './objects/stat';
import faq from './objects/faq';
import pageHeader from './objects/pageHeader';

// Export all schemas
export default [
	// Documents
	service,
	serviceCategory,
	blogPost,
	homePage,
	aboutPage,
	workshopPage,
	faqItem,
	servicesPage,
	contactPage,
	termsPage,
	privacyPage,
	siteSettings,
	booking,

	// Sections
	heroSection,
	uspSection,
	servicesSection,
	videoSection,
	topSellersSection,
	workshopsSection,
	testimonialsSection,
	partnersSection,
	statsSection,
	faqSection,

	// Objects
	workshopObject,
	testimonial,
	partner,
	stat,
	faq,
	pageHeader,
];
